import styled, { css } from 'styled-components';

import { defaultThemeProp } from '@pega/cosmos-react-core';

export const StyledCard = styled.article(props => {
  const {
    theme: {
      base: { spacing }
    }
  } = props;

  return css`
    width: 20rem;
    height: max-content;
    padding: ${spacing};
  `;
});

StyledCard.defaultProps = defaultThemeProp;
